<script setup lang="ts">
import { computed, ref } from "vue";
import type { DecorationIcon } from "#ui/decoration/types";
import TintedIcon from "#ui/primitives/tintedIcon/TintedIcon.vue";
import { isVectorIcon } from "#ui/utils/icon";

export interface Props {
	icon: DecorationIcon | null;
	fallback: string;
	size?: number;
}

const SVG_DATA_URI = /^data:image\/svg\+xml/i;

const props = withDefaults(defineProps<Props>(), { size: 24 });

const brokenUrl = ref<string | null>(null);

const customUrl = computed(() => (props.icon?.url && props.icon.url !== brokenUrl.value ? props.icon.url : null));
const source = computed(() => customUrl.value ?? props.fallback);
const isVector = computed(() => (customUrl.value ? SVG_DATA_URI.test(customUrl.value) || isVectorIcon(customUrl.value) : true));
const size = computed(() => (typeof props.icon?.size === "number" ? props.icon.size : props.size));
const sizeStyle = computed(() => (typeof props.icon?.size === "string" ? { width: props.icon.size, height: props.icon.size } : undefined));

const showFallback = () => {
	if (customUrl.value) brokenUrl.value = customUrl.value;
};
</script>

<template>
	<TintedIcon :src="source" :size="size" :vector="isVector" :style="sizeStyle" color="currentColor" @error="showFallback" />
</template>
